import Cookies from 'js-cookie';

class EmailVerificationService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.EMAIL_VERIFICATION = '/api/email';
        this.VERIFY = '/verify';
        this.GENERATE = '/generate';
    }
    
    async generateEmailVerificationCode(toEmail){
        try{
            let url = window.location.origin + this.EMAIL_VERIFICATION + this.GENERATE ;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: toEmail
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }

    async verifyEmailVerificationCode(verificationCodeMap){
        try{
            let url = window.location.origin + this.EMAIL_VERIFICATION + this.VERIFY;
            let csrfToken = Cookies.get('XSRF-TOKEN');
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(verificationCodeMap)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined) {
                        localStorage.setItem('errorUUID', data.uuid);
                    }
                    return data;
                });
        }
        catch(err){
            console.log(err);
        }
    }
}

export default EmailVerificationService;
